<div
  *ngIf="item$ | async as item"
  class="flex h-full w-full items-center justify-between"
>
  <div class="flex min-w-0 items-center">
    <mat-icon
      *ngIf="item.display?.icon.slug"
      class="charted-item-icon"
      [ngStyle]="{ color: item.display.colour.value }"
      [svgIcon]="item.display.icon.slug"
    />

    <div class="flex flex-col truncate">
      <span class="charted-item-label">{{ item.name }}</span>
      <small
        *ngIf="serviceCodeSummary$ | async as serviceCodeSummary"
        class="service-code-summary mat-caption truncate"
        >{{ serviceCodeSummary }}</small
      >
    </div>
  </div>

  <div class="flex items-center">
    <div class="flex items-center justify-end">
      @if (isMultiTreatment$ | async) {
        <mat-icon
          class="multi-treatment-icon"
          matTooltip="This will create multiple treatment steps"
        >
          list
        </mat-icon>
      }
      @if (quickChartEnabled) {
        @if (isInQuickChart$ | async) {
          <button
            mat-icon-button
            matTooltip="Remove from Quick Chart"
            (click)="removeFromQuickChart($event, item)"
          >
            <mat-icon>bookmark</mat-icon>
          </button>
        } @else {
          <button
            mat-icon-button
            matTooltip="Add to Quick Chart"
            (click)="addToQuickChart($event, item)"
          >
            <mat-icon>bookmark_border</mat-icon>
          </button>
        }
      }
    </div>
  </div>
</div>
